import apiClient from '../client'

const buildQuery = (params) => {
  const searchParams = new URLSearchParams()
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '') {
      searchParams.set(key, String(value))
    }
  })
  return searchParams.toString()
}

export const teamService = {
  list: async ({ search = '', status = '', page = 1, limit = 10, sortBy = 'createdAt:desc' } = {}) => {
    const query = buildQuery({ search, status, page, limit, sortBy })
    const response = await apiClient.get(`/teams${query ? `?${query}` : ''}`)
    return response.data
  },

  create: async (payload) => {
    const response = await apiClient.post('/teams', payload)
    return response.data
  },

  getById: async (memberId) => {
    const response = await apiClient.get(`/teams/${memberId}`)
    return response.data
  },

  update: async (memberId, payload) => {
    const response = await apiClient.patch(`/teams/${memberId}`, payload)
    return response.data
  },

  remove: async (memberId) => {
    await apiClient.delete(`/teams/${memberId}`)
    return true
  },
}
